import { render, staticRenderFns } from "./GopSideMenu.vue?vue&type=template&id=e52a281a&scoped=true"
import script from "./GopSideMenu.vue?vue&type=script&lang=js"
export * from "./GopSideMenu.vue?vue&type=script&lang=js"
import style0 from "./GopSideMenu.vue?vue&type=style&index=0&id=e52a281a&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52a281a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e52a281a')) {
      api.createRecord('e52a281a', component.options)
    } else {
      api.reload('e52a281a', component.options)
    }
    module.hot.accept("./GopSideMenu.vue?vue&type=template&id=e52a281a&scoped=true", function () {
      api.rerender('e52a281a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/sideMenu/GopSideMenu.vue"
export default component.exports